<style>
    .shopify-store-card-2{
        border: none;
        max-width: 640px;
        padding: 32px 0;
        border-bottom: 1px solid var(--border-color-1);
    }
    .shopify-store-card-2 .store-preview-image{
        display: inline-block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 15px;
    }
    .shopify-store-card-2 .store-logo{
        display: inline-block;
        width: 46px;
        height: 46px;
        object-fit: contain;
        border: 1px solid var(--text-subtle);
        background-color: white;
    }
    
    .shopify-store-card-2 .swiper-button-next,
    .shopify-store-card-2 .swiper-button-prev {
        height: 24px !important;
        width: 24px !important;
    }
    .shopify-store-card-2 .swiper-nav-wrapper-prev{
        left: 0;
    }
    .shopify-store-card-2 .swiper-nav-wrapper-next{
        right: 0;
    }
    .shopify-store-card-2 .swiper-initialized {
        height: 100%;
    }
    .shopify-store-card-2 .clamp-text{
        overflow: hidden;
        text-overflow: ellipsis;
        display: inline-block;
        max-height: 32px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .shopify-store-card-2 .preview-image-container{
        width: 200px; 
        height: 100%; 
        max-height: 250px;
        background-color: #a59186;
        border-radius: 15px;
        overflow: hidden;
    }
    
    @media(max-width: 992px){
        .shopify-store-card-2 .preview-image-container{
            width: 100%;
        }
    }
    @media(max-width: 576px){
        
    }
    
    
</style>

<script>
    import 'lazysizes';
    import carousel from "..//misc/carousel";
    import {shopifyHelperMixin} from "../../mixins/shopifyHelperMixin";
    import {shopifyStoreStructuredDataMixin} from "../../mixins/shopify/shopifyStoreStructuredDataMixin";

    export default {
        props: ['store'],
        components: {
            carousel
        },
        mixins: [shopifyHelperMixin, shopifyStoreStructuredDataMixin],
        data: function () {
            return {

            }
        },
        computed: {
            store_url: function(){
                var domain = this.store.domain || this.store.myshopify_domain;
                if(domain && !domain.includes('http')){
                    domain = 'http://' + domain;
                }
                return domain;
            },
            profile_url: function(){
                if(this.store.profile_url){
                    return this.store.profile_url;
                }
                
                var id = this.store.id;
                if(this.store.myshopify_domain){
                    id = this.store.myshopify_domain.split('.')[0];
                }

                var url = '/shop/' + id;
                return url;
                
            },
            store_thumbnail: function(){
                return this.store.image_url;
            },
            preview_images: function(){
                var self = this;
                var images = [];
                
                if(this.store._cover_images && this.store._cover_images.length){
                    images = this.store._cover_images.map(function(image_url){
                        return self.resizeImage(image_url, '_280x');
                    });
                } 
                
                return images;
            },
            address: function(){
                var address = '';
                var parts = [];

                if(this.store.city){
                    parts.push(this.store.city);
                }
                if(this.store.province){
                    parts.push(this.store.province);
                }

                address = parts.join(', ');

                return address;
            },
            carousel_options: function(){
                var options = {
                    direction: 'horizontal',
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: false,
                    freeMode: false,
                };

                return options;
            }
        },
        created: function () {

        },
        mounted: function () {

        },
        methods: {
            formatPhoneNumber: function(phone_number){
                var cleaned = ('' + phone_number).replace(/\D/g, '');
                var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
                if (match) {
                  var intlCode = (match[1] ? '+1 ' : '');
                  return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
                }
                return phone_number;
            },
            share: function(){
                var data = {
                    item: this.store,
                    url: this.profile_url,
                    title: 'Share ' + this.store.name
                };
                window.bus.$emit('social-share', data);
            }
        }
    };

</script>

<template>
    <article class="shopify-store-card-2">
        <script type="application/ld+json">
            {{store_structured_data}}
        </script>
        <div class="row no-gutters h-100">
            <div class="col-12 col-md-auto" v-if="preview_images.length">
                <div class="preview-image-container">
                    <carousel class="h-100" :options="carousel_options" :id="'store-logo-carousel-' + store.id" prev="1" next="1">
                        <div class="swiper-slide h-100" v-for="(image, i) in preview_images">
                            <img class="lazyload store-preview-image" :data-src="image" alt="Store Products Preview">
                        </div>
                    </carousel>
                </div>
            </div>
            <div class="col">
                <div class="row no-gutters flex-column p-3" style="min-height: 100%;">
                    <div class="col">
                        <div class="row row-sm align-items-center mb-2">
                            <div class="col-auto" v-if="store_thumbnail">
                                <img class="lazyload rounded-circle store-logo" :data-src="store_thumbnail" :alt="store.name">
                            </div>
                            <div class="col">
                                <h4 class="style-body-large">{{store.name}}</h4>
                                <p class="text-subtle clamp-text mb-0 fs-12">{{store.description}}</p>
                            </div>
                        </div>
                        <address>
                            <div class="mb-2" v-if="address"> {{address}} </div>
                            <div class="text-primary mb-2" v-if="store.phone"> 
                                <i class="fas fa-phone fa-fw fs-16 mr-1"></i> {{formatPhoneNumber(store.phone)}}
                            </div>
                            <div class="mb-2" v-if="store.email"> 
                                <a class="text-primary" :href="'mailto:' + store.email">
                                    <i class="fas fa-envelope fa-fw fs-16 mr-1"></i> {{store.email}}
                                </a>
                            </div>
                            <div class="mb-2">
                                <a class="fs-16 text-primary" :href="'mailto:' + store.email" v-if="store.email" hidden>
                                    <i class="fas fa-envelope fa-fw mr-1"></i> {{store.email}}
                                </a>
                                <template v-for="url in store.social_urls" v-if="url.includes('http')">
                                    <a class="fs-16" :href="url" target="_blank" title="Facebook" v-if="url.includes('facebook.com')">
                                        <i class="fab text-facebook fa-facebook fa-fw mr-1"></i>
                                        <span hidden>Facebook</span>
                                    </a>
                                    <a class="fs-16" :href="url" target="_blank" title="Instagram" v-else-if="url.includes('instagram.com')">
                                        <i class="fab text-instagram fa-instagram fa-fw mr-1"></i>
                                        <span hidden>Instagram</span>
                                    </a>
                                    <a class="fs-16" :href="url" target="_blank" title="Twitter" v-else-if="url.includes('twitter.com')">
                                        <i class="fab text-twitter fa-twitter fa-fw mr-1"></i>
                                        <span hidden>Twitter</span>
                                    </a>
                                    <a class="fs-16" :href="url" target="_blank" title="Youtube" v-else-if="url.includes('youtube.com')">
                                        <i class="fab text-youtube fa-youtube fa-fw mr-1"></i>
                                        <span hidden>YouTube</span>
                                    </a>
                                    <a class="fs-16" :href="url" target="_blank" title="Pinterest" v-else-if="url.includes('pinterest.com')">
                                        <i class="fab text-youtube fa-pinterest fa-fw mr-1"></i>
                                        <span hidden>Pinterest</span>
                                    </a>
                                    <a class="fs-16" :href="url" target="_blank" title="Store Website" v-else>
                                        <i class="fas fa-globe fa-fw mr-1"></i>
                                        <span hidden>Store Website</span>
                                    </a>
                                </template>
                            </div>
                        </address>
                    </div>
                    <div class="col-auto row align-items-center justify-content-between mt-3">
                        <div class="col-auto">
                            <a :href="profile_url" class="btn btn-primary rounded-pill">
                                <i class="fas fa-globe fa-fw"></i>
                                Store Page
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-default btn-icon rounded-circle" @click="share" title="Share this store">
                                <i class="fas fa-share-alt fa-fw"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/shopify/shopifyStoreCard2.vue